import { useHomeBanner, useOctoDAPAIWorkplaceHub, useOctoDAPAIWorkplaceHubDynamic } from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';
import WorkflowCard from '@/components/workflowCard';

const OctoDAPAIWorkplaceHubView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: octoDAPAIWorkplaceHub } = useOctoDAPAIWorkplaceHub(language);
    let octoDAPAIWorkplaceHubData = octoDAPAIWorkplaceHub?.data || {};
    const { data: octoDAPAIWorkplaceHubDynamic } = useOctoDAPAIWorkplaceHubDynamic(language);
    let octoDAPAIWorkplaceHubDynamicData = octoDAPAIWorkplaceHubDynamic?.data || {};

    return (
        <>
            <main className='theme-blue-gradient' id="start">
                <Banner banner={banner} category="OctoDAP AI Workplace Hub" />
                <Card cardData={ octoDAPAIWorkplaceHubData?.Cards?.Cards || []} cardType="white-card" />
                <WorkflowCard workflowdata={octoDAPAIWorkplaceHubData?.CommonAgenticWorkflow} language={language} />
                {/* DynamicContent */}
                <DynamicContent content={octoDAPAIWorkplaceHubDynamicData?.Content} />
            </main>
        </>
    );
}

export default OctoDAPAIWorkplaceHubView;